module.exports = __webpack_public_path__ + "img/底图@2x.4554068a.png";